<template>
  <div>
    <avue-crud :option="option" :data="list.value" ref="crud" @refresh-change="refreshChange">
      <!-- 自定义搜索框 -->
      <template slot="mySearch">
        <div class="search-contain">
          <Search></Search>
        </div>
      </template>
      <!-- 自定义表格列 -->
      <!-- <template #clientTypesDesc="{ row }">
        <div style="display: flex">
         
        </div>
      </template> -->
      <!-- 自定义表格操作栏 -->
      <template #menu="{ row }">
        <el-button v-auth="'ACTIVE_GOODS_MANAGE_LOG'" type="text" size="small" @click="viewLog(row)">查看日志</el-button>
        <el-button v-auth="'ACTIVE_GOODS_MANAGE_EDIT'" v-if="row.reviewStatus !== 2" type="text" size="small"
          @click="edit(row)">编辑</el-button>
        <el-button v-auth="'ACTIVE_GOODS_MANAGE_SUBMIT'" v-if="row.reviewStatus === 2" type="text" size="small"
          @click="auditShow(row.id)">审核</el-button>
        <el-button v-auth="'ACTIVE_GOODS_MANAGE_TO_SUBMIT'" v-if="row.reviewStatus === 1" type="text" size="small"
          @click="submitAuditShow(row.id)">提交审核</el-button>
        <el-button v-auth="'ACTIVE_GOODS_MANAGE_RECALL'" v-if="row.reviewStatus === 2" type="text" size="small"
          @click="revokeAudit(row.id)">撤销审核</el-button>
        <el-button v-auth="'ACTIVE_GOODS_MANAGE_DEL'" type="text" size="small" @click="del(row.id)">删除</el-button>
      </template>
    </avue-crud>
    <!-- 分页组件 -->
    <ElementPagination style="margin-bottom: 20px" :current-page="searchParams.current" :page-size="searchParams.size"
      :total="searchParams.total" :page-sizes="[10, 20, 30, 40, 50]" @size-change="handleSizeChange"
      @current-change="handleCurrentChange" />
    <!-- 提交审核 -->
    <AuditDialog ref="auditDialog">
      <template #submitFooter="scope">
        <div>
          <el-button type="primary" size="small" @click="submitAudit(scope)">确认提交审核</el-button>
        </div>
      </template>
      <template #auditFooter="scope">
        <div style="display: flex; flex-direction: column; align-items: center">
          <div style="display: flex; margin-bottom: 10px">
            <el-button style="width: 100px; margin-right: 10px" size="small" @click="auditPass(scope)">审核通过</el-button>
            <el-button style="width: 100px" type="primary" size="small" @click="auditReject(scope)">审核不通过</el-button>
          </div>
          <div>
            <el-input class="auditOpinion" v-model="auditOpinion" maxlength="999" size="small" clearable
              placeholder="审核意见"></el-input>
          </div>
        </div>
      </template>
    </AuditDialog>
    <!-- 操作日志 -->
    <OptionLog ref="optionLog" :columnConfig="optionLogColumn" @reload="reloadOpt" :closeBtn="false">
      <template #type="{ row }">
        <div>
          <!-- 操作类型(1-新增, 2-修改, 3-删除, 4-提交审核, 5-撤销审核, 6-审核通过, 7-审核拒绝) -->
          <span v-if="row.type === 1">新增</span>
          <span v-if="row.type === 2">修改</span>
          <span v-if="row.type === 3">删除</span>
          <span v-if="row.type === 4">提交审核</span>
          <span v-if="row.type === 5">撤销审核</span>
          <span v-if="row.type === 6">审核通过</span>
          <span v-if="row.type === 7">审核拒绝</span>
        </div>
      </template>
    </OptionLog>
    <!-- 编辑 -->
    <AddDialog ref="addDialog"></AddDialog>
  </div>
</template>

<script>
import Search from "./Search.vue";
import ElementPagination from "@/components/ElementPagination";
import Message from "@/components/Message";
import AuditDialog from "@/components/OptionsLog/auditDialog.vue";
import OptionLog from "@/components/OptionsLog/optionLog.vue";
import AddDialog from './Add.vue'
import { getSalePeriodUnit } from "@/views/memberNew/activeCode/helper/index"
import { deleteActiveGoodsLocal, getActiveGoodsLocalDetail, submitAuditActiveGoodsLocal, auditPassActiveGoodsLocal, auditNotPassActiveGoodsLocal, cancelAuditActiveGoodsLocal, getActiveGoodsLocalLog } from '@/api/memberNew/activeGoods'
import { submitAuditTrans, } from '../../helper/index'
import { cloneDeep } from "lodash";
export default {
  name: "WebSaaSTable",
  inject: ["currentTab", "list", "searchParams", "cdkeyMemberList", "unionGoodsList", "getList"],
  provide() {
    return {
      cdkeyMemberList: this.cdkeyMemberList,
      unionGoodsList: this.unionGoodsList,
      getList: this.getList,
    };
  },
  components: {
    Search,
    ElementPagination,
    AuditDialog,
    OptionLog,
    AddDialog
  },
  watch: {
    "currentTab.value"(val) {
      console.log("currentTab.value", val);
      if (val === "online") {
        /** 操作栏消失 */
        this.option.menu = false;

        const index = this.option.column.findIndex(
          (item) => item.label === "审核状态"
        );
        if (index) {
          this.option.column.splice(index, 1);
        }
      } else {
        /** 操作栏出现 */
        this.option.menu = true;
        // this.option.menuWidth = 180;
        // delete this.option.menuWidth;
        const index = this.option.column.findIndex(
          (item) => item.label === "审核状态"
        );
        if (index === -1) {
          this.option.column.push({
            label: "审核状态",
            width: "80",
            prop: "reviewStatus",
            // 审核状态：1-草稿 2-待审核 3-通过 4-未通过
            dicData: [
              {
                label: "草稿",
                value: 1,
              },
              {
                label: "待审核",
                value: 2,
              },
              {
                label: "通过",
                value: 3,
              },
              {
                label: "未通过",
                value: 4,
              },
            ],
          });
        }
      }
      this.$refs.crud.refreshTable();
    },
  },
  data() {
    return {
      /** 审核意见 */
      auditOpinion: "",
      option: {
        lazy: true,
        tip: false,
        simplePage: true,
        searchShow: true,
        // searchMenuSpan: 6,
        tree: true,
        border: true,
        /** 表格索引 */
        index: false,
        /** 表格搜索显隐按钮 */
        searchShowBtn: true,
        /** 是否启用功能按钮 */
        searchIcon: true,
        searchIndex: 0,
        /** 表格查看按钮 */
        viewBtn: false,
        /** 表格新增按钮 */
        addBtn: false,
        /** 表格删除按钮 */
        delBtn: false,
        /** 表格修改按钮 */
        editBtn: false,
        /** 导出按钮 */
        excelBtn: false,
        /** 是否有选择框	 */
        selection: false,
        /** 表格高度 */
        height: 500,
        /** 是否有操作栏 */
        menu: true,
        /** 表格搜索按钮 */
        // searchBtn: false,
        /** 表格清空按钮 */
        // emptyBtn: false,
        /** 开启拖拽功能 */
        // sortable: true,
        // dragHandler: true,
        // rowSort: true,
        // columnSort: true,
        // menuWidth: 200,
        /** 空数据时显示的文本内容 */
        emptyText: '-',
        column: [
          {
            label: "ID",
            width: "50",
            prop: "id",
            // slot: true,
            /** 当内容过长被隐藏时显示 tooltip */
            overHidden: false,
            // search: true,
            columnBtn: false,
            /** 搜索项位置排序，序号越大越靠前 */
            // searchOrder: 1,
          },
          {
            label: "激活码名称",
            width: "120",
            prop: "name",
            /** 当内容过长被隐藏时显示 tooltip */
            overHidden: true,
          },
          {
            label: "激活码会员",
            width: "120",
            prop: "memberTypeId",
            formatter: (row, column, cellValue) => {
              const item = this.cdkeyMemberList.value.find(
                (item) => item.id == cellValue
              );
              return item ? item.name : "-";
            },
          },
          {
            label: "定价周期",
            width: "80",
            prop: "salePeriod",
            formatter: (row, column, cellValue) => {
              return cellValue + "" + getSalePeriodUnit(row.salePeriodUnit)
            },

          },
          {
            label: "售价",
            width: "80",
            prop: "salePrice",
            formatter: (row, column, cellValue) => {
              return cellValue + '元'
            }
          },

          {
            label: "联运商品",
            width: "120",
            prop: "unionGoodsId",
            /** 当内容过长被隐藏时显示 tooltip */
            overHidden: true,
            formatter: (row, column, cellValue) => {
              if (cellValue === 0) {
                return "-";
              }
              const item = this.unionGoodsList.value.find(
                (item) => item.id == cellValue
              );
              return item ? item.partnerName + ' ' + item.salePeriodDescr + ' ' + item.salePrice + '元' : "-";
            },
          },
          {
            label: "前端可见",
            width: "90",
            prop: "frontVisible",
            dicData: [
              {
                label: "是",
                value: 1,
              },
              {
                label: "否",
                value: 0,
              },
            ],
          },
          {
            label: "状态",
            width: "90",
            prop: "status",
            dicData: [
              {
                label: "生效",
                value: 1,
              },
              {
                label: "失效",
                value: 0,
              },
            ],
          },
          {
            label: "审核状态",
            width: "90",
            prop: "reviewStatus",
            // 1-起草中，2-待审核，3-审核通过，4-审核不通过"
            dicData: [
              {
                label: "草稿",
                value: 1,
              },
              {
                label: "待审核",
                value: 2,
              },
              {
                label: "通过",
                value: 3,
              },
              {
                label: "未通过",
                value: 4,
              },
            ],
          },
          {
            label: "备注",
            prop: "descr",
            /** 当内容过长被隐藏时显示 tooltip */
            overHidden: true,
            formatter: (row, column, cellValue) => {
              return cellValue || "-";
            },
          },

          {
            label: "",
            prop: "my",
            hide: true,
            showColumn: false,
            search: true,
            display: false,
            menuClassName: "myClass",
            searchslot: true,
          },
        ],
      },
      /** 操作日志配置列 */
      optionLogColumn: [
        {
          prop: "operateTime",
          label: "操作时间",
        },
        {
          prop: "operator",
          label: "操作人",
        },
        {
          prop: "type",
          label: "操作类型",
          slot: "type",
        },
        {
          prop: "description",
          label: "审核意见",
        },
      ],
    };
  },

  methods: {
    /** 刷新 */
    refreshChange() {
      this.getList();
      Message.success("刷新成功");
    },
    //^ ^--------------操作栏内的事件-------------^ ^
    /** 编辑 */
    edit(row) {
      console.log("编辑", row);
      this.$refs.addDialog.show(row, 'edit');
    },
    /** 删除 */
    del(id) {
      console.log("删除", id);
      /** 二次确认  */
      this.$confirm("此操作将永久删除该商品, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const { data } = await deleteActiveGoodsLocal(id);
          console.log("删除的响应", data);
          if (data.code === 200) {
            Message.success("删除成功");
            this.getList();
          }
        })
        .catch(() => {
          console.log('删除失败');
        });

    },
    /** 提交审核 */
    async submitAuditShow(id) {
      /** 先获取详情 */
      const { data } = await getActiveGoodsLocalDetail(id);
      console.log("获取详情的响应", data);
      /** 赋值id */
      this.$refs.auditDialog.id = id
      this.$refs.auditDialog.show(submitAuditTrans(data.data));
      this.$refs.auditDialog.slotControl.submitFooter = true;
    },
    /** 确认提交审核 */
    async submitAudit() {
      console.log("确认提交审核");
      const id = this.$refs.auditDialog.id;
      const { data } = await submitAuditActiveGoodsLocal(id);
      if (data.code === 200) {
        Message.success("提交审核成功");
        this.getList();
        this.$refs.auditDialog.hide();
      }
    },
    /** 撤销审核 */
    async revokeAudit(id) {
      console.log("撤销审核", id);
      /** 二次询问 */
      this.$confirm("此操作将撤销审核, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const { data } = await cancelAuditActiveGoodsLocal(id);
          console.log("撤销审核的响应", data);
          if (data.code === 200) {
            Message.success("撤销审核成功");
            this.getList();
          }
        })
        .catch(() => {
          console.log('撤销审核失败');
        });
    },
    /** 审核 */
    async auditShow(id) {
      /** 先获取详情 */
      const { data } = await getActiveGoodsLocalDetail(id);
      console.log("获取详情的响应", data);
      /** 赋值id */
      this.$refs.auditDialog.id = id
      this.auditOpinion = ''
      this.$refs.auditDialog.show(submitAuditTrans(data.data));

      this.$refs.auditDialog.slotControl.auditFooter = true;
    },
    /** 审核通过 */
    async auditPass() {
      console.log("审核通过");
      const id = this.$refs.auditDialog.id;
      const { data } = await auditPassActiveGoodsLocal({
        id,
        reviewDescr: this.auditOpinion,
      });
      if (data.code === 200) {
        Message.success("审核通过成功");
        this.getList();
        this.$refs.auditDialog.hide();
      }
    },
    /** 审核不通过 */
    async auditReject() {
      console.log("审核不通过");
      const id = this.$refs.auditDialog.id;
      const { data } = await auditNotPassActiveGoodsLocal({
        id,
        reviewDescr: this.auditOpinion,
      });
      if (data.code === 200) {
        Message.success("审核不通过成功");
        this.getList();
        this.$refs.auditDialog.hide();
      }
    },
    /** 查看日志 */
    async viewLog(row) {
      console.log("查看日志", row.id);
      const optSearch = this.$refs.optionLog.searchParams;
      const { data } = await getActiveGoodsLocalLog({
        ...optSearch,
        subjectId: row.id,
      });
      console.log("查看日志的响应", data);
      const list = cloneDeep(data.data.records);
      optSearch.total = data.data.total || 0
      this.$refs.optionLog.show(
        list,
        row.id
      );

    },
    /** 日志分页 */
    async reloadOpt(id) {
      console.log("日志分页", id);
      const optSearch = this.$refs.optionLog.searchParams;
      const { data } = await getActiveGoodsLocalLog({
        ...optSearch,
        subjectId: id,
      });
      console.log("查看日志的响应", data);
      const list = cloneDeep(data.data.records);
      this.$refs.optionLog.list = list;
      this.$refs.optionLog.searchParams.total = data.data.total;
    },
    //^ ^--------------分页相关-------------^ ^
    /** 每页条数change */
    handleSizeChange(val) {
      this.searchParams.size = val;
      Message.success(`每页 ${val} 条`);
      /** 更新数据 */
      this.getList();
    },
    /** 当前页change */
    handleCurrentChange(val) {
      this.searchParams.current = val;
      Message.success(`当前页 ${val}`);
      /** 更新数据 */
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.auditOpinion {
  ::v-deep .el-input__inner {
    text-align: center;
    width: 300px;
  }
}

::v-deep .avue-crud__pagination {
  display: none !important;
}

::v-deep .avue-form__group {
  .el-col {
    padding: 0px !important;
    margin: 0px !important;
  }
}

.avue-crud .avue-input-number,
.avue-crud .el-cascader,
.avue-crud .el-date-editor.el-input,
.avue-crud .el-date-editor.el-input__inner,
.avue-crud .el-select,
.avue-form .avue-input-number,
.avue-form .el-cascader,
.avue-form .el-date-editor.el-input,
.avue-form .el-date-editor.el-input__inner,
.avue-form .el-select {
  width: 70% !important;
}

::v-deep .avue-form__menu--center {
  display: none !important;
}

::v-deep .avue-form__group .el-col-md-6 {
  width: 100%;
}

::v-deep .avue-form__group .el-form-item__content {
  margin-left: 0px !important;
}

::v-deep .avue-crud .avue-crud__search .avue-form .avue-form__group .avue-form__row .el-form-item label {
  float: none;
  display: inline-block;
  width: 100%;
}
</style>